// Renders DI's raw table extraction in a tabular form. Row 0 (which
// our header detection treats as headers) is highlighted blue so it's
// easy to spot when DI mistakenly bundled a "title" row at index 0
// (the bug pattern that blocked Fredon).

interface DiTable {
  rowCount: number;
  columnCount: number;
  headers?: string[];
  cells?: Array<{ rowIndex: number; columnIndex: number; content: string }>;
}

export function AdminDiTables({ tables }: { tables: DiTable[] }) {
  if (tables.length === 0) {
    return <em style={{ color: "var(--bsp-fg-muted)" }}>DI returned no tables.</em>;
  }
  return (
    <div style={{ display: "grid", gap: 12 }}>
      {tables.map((t, idx) => (
        <DiTableCard key={idx} table={t} index={idx} />
      ))}
    </div>
  );
}

function DiTableCard({ table, index }: { table: DiTable; index: number }) {
  const rows: string[][] = [];
  for (let r = 0; r < table.rowCount; r++) {
    const row: string[] = [];
    for (let c = 0; c < table.columnCount; c++) {
      const cell = (table.cells ?? []).find(
        (x) => x.rowIndex === r && x.columnIndex === c,
      );
      row.push(cell?.content ?? "");
    }
    rows.push(row);
  }
  return (
    <div style={{ border: "1px solid var(--bsp-border)", borderRadius: 4, padding: 10 }}>
      <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6 }}>
        Table {index + 1} — {table.rowCount}×{table.columnCount}
        {table.headers && (
          <span style={{ marginLeft: 8, color: "var(--bsp-fg-muted)", fontWeight: 400 }}>
            headers (row 0): [{table.headers.map((h) => `"${h}"`).join(", ")}]
          </span>
        )}
      </div>
      <table className="bsp-table" style={{ fontSize: 11 }}>
        <tbody>
          {rows.map((row, r) => (
            <tr key={r} style={r === 0 ? { background: "var(--bsp-blue-pale)" } : undefined}>
              {row.map((cell, c) => (
                <td key={c} style={{ padding: "4px 8px", border: "1px solid var(--bsp-border)" }}>
                  {cell || <span style={{ color: "var(--bsp-fg-muted)" }}>—</span>}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
